"use client";
import React, { useCallback, useMemo, useRef, useState } from "react";

import { ScriptsContext } from "@stadium/hooks/lib/use-scripts";

const ScriptsProvider = ({ children }) => {
  const [scripts, setScripts] = useState({});
  const loadingRefs = useRef({});

  const setCustomScript = useCallback((scriptId, scriptData) =>
    setScripts((prevScripts) => ({ ...prevScripts, [scriptId]: scriptData }))
  ,[setScripts]);

  const value = useMemo(
    () => ({
      ...scripts,
      loadingRefs,
      setScript: setCustomScript,
    }),
    [scripts, loadingRefs, setCustomScript],
  );

  return <ScriptsContext.Provider value={value}>{children}</ScriptsContext.Provider>;
};

export default ScriptsProvider;
